import { State, Store } from '@ngxs/store';
import { UserService } from '../../../common/auth/services/user.service';
import { TasksState } from '../../../common/store/task';
import { Injectable, inject } from '@angular/core';
import { taskStateConfig } from '../../../common/store/task/task-state.config';
import { Request } from '../../../common/shared/interfaces/IRequest';
import { MDLA_SCOPE, MDLAScope } from '../../../common/shared/tokens/mdla-scope.token';
import { NamRequestService } from '../../services/request.service';
import { TranslateService } from '@ngx-translate/core';
@State({
    ...taskStateConfig,
    name: 'namTasksState'
})
@Injectable()
export class NamTasksState extends TasksState<Request, Request> {
    protected override requestService: NamRequestService;
    protected override userService: UserService;
    protected override store: Store;
    protected override stateScope: MDLAScope;
    protected override translateService: TranslateService;

    constructor() {
        const requestService: NamRequestService = inject(NamRequestService);
        const userService: UserService = inject(UserService);
        const store: Store = inject(Store);
        const stateScope: MDLAScope = inject<MDLAScope>(MDLA_SCOPE);
        const translateService: TranslateService = inject(TranslateService);

        super(userService, store, requestService, stateScope, translateService);

        this.requestService = requestService;
        this.userService = userService;
        this.store = store;
        this.stateScope = stateScope;
        this.translateService = translateService;
    }
}
